<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col d-flex justify-content-between align-items-center">
        <div>
          <h5 class="modal-title">Review Guest</h5>
        </div>
        <div>
          <button (click)="dialogRef.close()" type="button" class="btn btn-outline-light mr-3">
            <i class="far fa-times"></i> cancel
          </button>
          <button
            (click)="onSave(form)"
            type="button"
            [disabled]="isLoading || !isEditable"
            class="btn btn-secondary-info create-btn"
          >
            <i class="cs-icon cs-icon-save"></i> Save
          </button>
        </div>
      </div>
      <a (click)="dialogRef.close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="alert alert-warning" *ngIf="isExpired">It is expired, you cannot add review to this guest.</div>
      <form [formGroup]="form">
        <div class="category-reviews">
          <div class="review-item" *ngFor="let item of categoryRatings.controls; let i = index" [formGroup]="item">
            <div class="row">
              <div class="col-sm-6">
                <mat-form-field2 class="mat-block category-select">
                  <mat-select
                    formControlName="category"
                    i18n-placeholder
                    placeholder="Category"
                    (selectionChange)="item.get('review_category_tags').reset([])"
                    required
                  >
                    <mat-option *ngFor="let c of categories" [value]="c"> {{ c | startCase }}</mat-option>
                  </mat-select>
                </mat-form-field2>
              </div>
              <div class="col-sm-6">
                <div class="my-2">Rating</div>
                <app-rating
                  [rating]="item.get('rating').value"
                  [editable]="true"
                  (rate)="onRate(item, $event)"
                ></app-rating>
                <mat-error *ngIf="item.get('rating').touched && item.get('rating').hasError('required')">
                  Please rate this category
                </mat-error>
              </div>
              <div class="col-sm-12">
                <mat-form-field2 class="mat-block">
                  <input matInput placeholder="Comment" formControlName="comment" />
                </mat-form-field2>
              </div>
              <div class="col-sm-12">
                <mat-form-field2 class="mat-block">
                  <app-select
                    [items]="tags[item.get('category').value]"
                    bindLabel="label"
                    bindValue="id"
                    [multiple]="true"
                    placeholder="Category Tags"
                    formControlName="review_category_tags"
                  ></app-select>
                </mat-form-field2>
              </div>
            </div>
          </div>
        </div>
        <div class="review-item mt-3">
          <div *ngIf="isEditable">
            <div class="row">
              <div class="col-sm-6">
                <app-select-search
                  [items]="templates$ | async"
                  (valueChange)="onPublicTemplateChange($event)"
                  [hasBlank]="true"
                  [multiple]="false"
                  bindLabel="name"
                  placeholder="Select a Review Template"
                  i18n-placeholder
                  [inline]="false"
                  class="mat-block"
                ></app-select-search>
              </div>
              <div class="col-sm-6">
                <div class="d-flex gap-3">
                  <div *ngIf="inquiry?.ratings">
                    <label class="form-field-label mb-3" i18n>Assigned Booking Rating</label>
                    <app-booking-rating [rating]="inquiry?.ratings" style="font-size: 1.1rem"></app-booking-rating>
                  </div>
                  <button
                    type="button"
                    class="btn btn-secondary-info align-input-row-end"
                    [disabled]="isGeneratingAIReview"
                    (click)="onAIGuestReview()"
                  >
                    <i class="far fa-spin fa-spinner" *ngIf="isGeneratingAIReview"></i>
                    <i class="cs-icon cs-icon-ai" *ngIf="!isGeneratingAIReview"></i>
                    <ng-container i18n>Generate with AI</ng-container>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <mat-form-field2 class="mat-block">
            <textarea
              matInput
              [rows]="6"
              placeholder="Public Review"
              [required]="true"
              formControlName="public_review"
              cdkTextareaAutosize
            ></textarea>
          </mat-form-field2>
        </div>
        <div class="review-item mt-3">
          <div class="row" *ngIf="isEditable">
            <div class="col-sm-6">
              <app-select-search
                [items]="templates$ | async"
                (valueChange)="onPrivateTemplateChange($event)"
                [hasBlank]="true"
                [multiple]="false"
                bindLabel="name"
                placeholder="Select a Review Template"
                [inline]="false"
              ></app-select-search>
            </div>
          </div>
          <mat-form-field2 class="mat-block">
            <textarea
              matInput
              [rows]="6"
              placeholder="Private Feedback"
              formControlName="private_feedback"
              cdkTextareaAutosize
            ></textarea>
          </mat-form-field2>
        </div>
        <div class="review-item mt-3 recommneded-guest" *ngIf="form.get('is_reviewee_recommended') as ctrl">
          <div class="mb-3" [class.text-danger]="ctrl.touched && ctrl.hasError('required')">
            Do you recommend this guest?
          </div>
          <i class="fa-thumbs-up" [ngClass]="ctrl.value === true ? 'fas' : 'fal'" (click)="onRecommend(true)"></i>
          <i class="fa-thumbs-down" [ngClass]="ctrl.value === false ? 'fas' : 'fal'" (click)="onRecommend(false)"></i>
        </div>
      </form>
    </div>
  </div>
</div>
